<ng-template #modal>
  <div>
    <router-outlet></router-outlet>
  </div>
</ng-template>
